// Conditional visibility for dynamic portal form fields. A field can carry a
// `visible_when` rule { field: <controlling key>, operator: 'equals' |
// 'not_equals', value: <string> }. The field renders only when the rule
// matches the current form_data. This is mirrored 1:1 on the backend
// (serviceDeskPublic.js) so server validation and the UI agree.
export function isFieldVisible(field, formData) {
  const c = field && field.visible_when;
  if (!c || !c.field) return true;
  const actual = formData ? formData[c.field] : undefined;
  const target = c.value;
  let eq;
  if (Array.isArray(actual)) eq = actual.map(String).includes(String(target));
  else if (typeof actual === 'boolean') eq = String(actual) === String(target);
  else eq = String(actual ?? '') === String(target ?? '');
  return c.operator === 'not_equals' ? !eq : eq;
}
